import React from 'react';
import PropTypes from 'prop-types';
import { Header, Icon, Label, Segment } from 'semantic-ui-react';
import { InputBar, Messages } from './components';

class ChatComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showTyping: false,
    };
    this._handleSubmit = this._handleSubmit.bind(this);
  }

  _handleSubmit(text) {
    const { currentUser } = this.props;
    if (text.trim().length === 0) {
      return;
    }
    const { username, id } = currentUser;
    this.props.onSendMessage({ text, username, userId: id });
  }

  render() {
    const { currentUser, messages, occupancy } = this.props;
    const { showTyping } = this.state;
    if (!currentUser) {
      return <div />;
    }
    return (
      <Segment style={{ margin: 0 }}>
        <Header>
          <Label style={{ backgroundColor: 'white' }}>
            {currentUser.username}
          </Label>
          <Label>
            <Icon name="user" />
            {occupancy} <Label.Detail>online</Label.Detail>
          </Label>
        </Header>
        <Messages showTyping={showTyping} messages={messages} />
        <InputBar onSubmit={this._handleSubmit} />
      </Segment>
    );
  }
}

ChatComponent.propTypes = {
  currentUser: PropTypes.object.isRequired,
  occupancy: PropTypes.number.isRequired,
  onSendMessage: PropTypes.func,
};

export default ChatComponent;



// WEBPACK FOOTER //
// ./src/containers/Chat/components/ChatComponent/index.jsx